module.exports = __webpack_public_path__ + "media/svg/tz-aac7f2fe.svg";